import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import { SnackbarProvider } from "./context/SnackbarContext";
import { UserProvider } from "./context/userContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import msalInstance from "./config/msalConfig";

export default function AppCore() {
  return (
    <SnackbarProvider>
      <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
        <MsalProvider instance={msalInstance}>
          <UserProvider>
            <App />
          </UserProvider>
        </MsalProvider>
      </GoogleOAuthProvider>
    </SnackbarProvider>
  );
}
